
export default {
  props: {
    product: {
      type: Object,
      default: null
    },
    label: {
      type: Boolean,
      default: true
    },
    vertical: {
      type: Boolean,
      default: false
    },
    noPriceLabel: {
      type: Boolean,
      default: true
    },
    short: {
      type: Boolean,
      default: true
    }
  },
  vessel: {
    item: {
      $vertical: {
        display(val) {
          return val ? 'block' : null
        }
      },
      marginRight: '2xs'
    }
  },
  computed: {
    hasPrice() {
      return this.product.price > 0
    },
    showPrice() {
      return this.hasPrice || this.noPriceLabel == false
    },
    hasVariants() {
      return Boolean(this.product.variantsCount)
    },
    onSale() {
      return this.hasPrice && this.product.onSale
    },
    showLabel() {
      return this.short
        ? this.label && !this.onSale
        : this.label
    },
    tooltip() {
      return !this.hasPrice && this.$t('product.noPrice.tooltip')
    },
    text() {
      return this.hasVariants && this.hasPrice
        ? this.short ? this.$t('product.from') : this.$t('product.priceFrom')
        : this.$t('price')
    }
  },
  methods: {
    priceText(type) {
      return this.hasPrice
        ? this.product[`${type}Money`].formatted
        : this.$t('product.noPrice.price')
    }
  }
}
